var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.html",value:(_vm.popoverBody),expression:"popoverBody",modifiers:{"hover":true,"html":true}}],staticClass:"collectable-item-img",attrs:{"src":_vm.requireItemImage(_vm.itemType),"alt":_vm.item.nom,"title":_vm.item.nom}})
}
var staticRenderFns = []

export { render, staticRenderFns }